<template>
  <div
    class="cell_with_copy flex items-center justify-between w-full gap-2 group"
  >
    <a
      v-if="isLinkable"
      :href="formattedHref"
      target="_blank"
      rel="noopener noreferrer"
      class="flex-1 min-w-0 truncate text-inherit no-underline hover:underline cursor-pointer"
      :title="displayValue"
      @click.stop
    >
      {{ displayValue }}
    </a>
    <span v-else class="flex-1 min-w-0 truncate" :title="displayValue">
      {{ displayValue }}
    </span>
    <div
      v-if="hasValue"
      class="copy_action hidden group-hover:flex items-center justify-end p-2 rounded-lg border border_8 bg_color cursor-pointer flex-shrink-0"
      @click.stop="handleCopy"
    >
      <a-tooltip :title="tooltipText">
        <ThemeImage :icon="imageNames.COPY_GREY" alt="copy" class="size-4" />
      </a-tooltip>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { imageNames } from "@/src/constants/imageConstants.js";
import { linkableAttributeTypes } from "@/src/constants/crmConstants.js";
import { formatHref } from "@/src/utils/utils.js";
import ThemeImage from "@/src/components/ThemeImage.vue";

const props = defineProps({
  value: {
    type: [String, Number, Object, Array, Boolean],
    default: "",
  },
  attributeType: {
    type: String,
    default: null,
  },
});

const copied = ref(false);

const tooltipText = computed(() => (copied.value ? "Copied!" : "Copy"));

const isLinkable = computed(() => {
  if (!props.attributeType || !linkableAttributeTypes.has(props.attributeType)) return false;
  const val = displayValue.value;
  return val && val !== "--";
});

const formattedHref = computed(() => formatHref(displayValue.value));

const hasValue = computed(() => {
  return props.value !== null && props.value !== undefined && props.value !== "";
});

const displayValue = computed(() => {
  if (props.value === null || props.value === undefined || props.value === "") {
    return "--";
  }
  if (typeof props.value === "object") {
    return JSON.stringify(props.value);
  }
  return props.value;
});

const handleCopy = async () => {
  const value = props.value ?? "";
  const textToCopy =
    typeof value === "object" ? JSON.stringify(value) : String(value);
  try {
    await navigator.clipboard.writeText(textToCopy);
    copied.value = true;
    setTimeout(() => {
      copied.value = false;
    }, 1500);
  } catch (err) {
    console.error("Failed to copy:", err);
  }
};
</script>
